import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  frequencyFieldsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  timeUnitsSelect: {
    width: 90,
    marginTop: [0, '!important']
  },
  timeUnitsCount: {
    width: 40,
    marginTop: [0, '!important'],
    '&.inlineField input': {
      padding: [10, '!important']
    }
  },
  frequencyField: {
    maxWidth: [40, '!important'],
    '&.inlineField input': {
      padding: [10, '!important']
    }
  }
})

export default useStyles
